/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Channel_NameInputs */

const en_wb_management_channel_name = /** @type {(inputs: Wb_Management_Channel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# team-updates`)
};

const lv_wb_management_channel_name = /** @type {(inputs: Wb_Management_Channel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# komandas-zinas`)
};

/**
* | output |
* | --- |
* | "# team-updates" |
*
* @param {Wb_Management_Channel_NameInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_channel_name = /** @type {((inputs?: Wb_Management_Channel_NameInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Channel_NameInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_channel_name(inputs)
	return en_wb_management_channel_name(inputs)
});